import { Button, Row, Col } from "antd";
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SvgForbidden from 'components/Svgs/403';

const logo = <svg xmlns="http://www.w3.org/2000/svg" width="32" height="31.966" viewBox="0 0 32 31.966">
  <path fill="currentcolor" d="M123.112.778a15.985,15.985,0,0,0-13.745,24.145h0L107.085,32.7l7.875-2.187A15.983,15.983,0,1,0,123.11.772m.872,9.135a3.5,3.5,0,0,1,1.139-1.5c.991-.98.7-2.093.211-3.575-.095-.285.187-.393.486-.393a1.139,1.139,0,0,1,.427.077.889.889,0,0,1,.4.307,2.588,2.588,0,0,1,.11,2.251,3.414,3.414,0,0,0-.33,2.018,2.5,2.5,0,0,0,.4.8c.359.519.488,1.5-.366,1.68a1.422,1.422,0,0,1-.27.024,2.122,2.122,0,0,1-1.333-.51,1.007,1.007,0,0,1-.6-.3,1.08,1.08,0,0,1-.27-.869m2.515,7.9C125.073,22.416,120.715,27,118.08,26a13.987,13.987,0,0,0,2.943-5.857c.534-2.562-.022-5.519,1.322-7.842a8.956,8.956,0,0,1,1.508-2.028,1.167,1.167,0,0,0,.3.6,1.074,1.074,0,0,0,.635.33,2.24,2.24,0,0,0,1.4.525,1.825,1.825,0,0,0,.3-.028.9.9,0,0,0,.611-.4,13.125,13.125,0,0,1-.6,6.506" transform="translate(-107.085 -0.772)"></path>
</svg>

const ErrorOne = () => {
	const theme = useSelector(state => state.theme.currentTheme)
	return (
		<div style={{ height: "100vh" }}>
			<div >
				<div className="container-fluid d-flex flex-column justify-content-between h-100 px-md-4 pb-md-4 pt-md-1">
					<div className="container">
						<Row align="middle">
							<Col xs={24} sm={24} md={8}>
								<h1 className="font-weight-bold mb-4 display-4">Acesso negado</h1>
								<p className="font-size-md mb-4">Você não pode acessar essa página, mas não se preocupe, nós o ajudaremos a encontrar o caminho correto.</p>
								<Link to='/dashboard'>
									<Button type="primary" icon={<ArrowLeftOutlined />}>Voltar</Button>
								</Link>
							</Col>
							<Col xs={24} sm={24} md={{ span: 14, offset: 2 }}>
								<SvgForbidden/>
							</Col>
						</Row>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ErrorOne
